// extracted by mini-css-extract-plugin
export default {"content":"OurServicePage_content__GVT80","highlightText":"OurServicePage_highlightText__6Zr5R","groupServiceSection":"OurServicePage_groupServiceSection__RZEL4"};